import * as React from 'react';
import * as SignalR from "@microsoft/signalr";
import { Auth, AuthenticationState, IAuthenticationService, AuthenticationService } from '../Services/AuthenticationService';
import { SignalRConnection } from '../Services/ConnectionService';
import { DataLoader, Layout, SafeRedirect, CustomSpinner, Center, FullView, IdleChecker } from '../Components';
import * as SiteLogo from 'Assets/Images/site_logo.png';
import * as CompanyLogo from 'Assets/Images/company_logo.png';
import { EventModal } from '../Components/EventModal';
import { GlobalProvider, AuthProvider } from '../Context';
import { Fade, Spinner, Row, Col } from 'reactstrap';
import { Route } from 'react-router';
import { Switch } from 'react-router-dom';
import { Dashboard, CalibrateScanner, Settings, Echo, LicenseError, Downloads, } from '../Pages';
import { EventHandlerService, EventHandlerProvider } from '../Services/EventHandlerService';
import Endpoints from '../Utils/Endpoints';
import './Styles/AuthenticatedApp.css';
import { getJson, UserRequestHeaders } from '../Services';
import { PasswordResetLanding, TwoFactorAuthentication } from './Components';
import History from '../Utils/History';
import { VeriLiteInformationEvent, VeriLiteEventAction } from '../Types/Exports';

export interface IAuthenticatedAppProps {
    location: any;
}

export interface IAuthenticatedAppState {
    isConnected: boolean;
    finishedLoading: boolean;    
    applicationData: IAuthenticatedAppData;
    eventHandler: EventHandlerService;
}

export interface IAuthenticatedAppData {
    [key: string]: any;
    resources: any;
    supportedLanguages: any;
    selectedLanguage: any;
    userInfo: any;
    availableActions: any;
    calibrationData: any;
    locations: any;
    selectedLocation: any;
    apiProvider: any;
    multipleQueueCount: any;
    deferredQueueCount: any;
    connectionState: SignalR.HubConnectionState;
    nbsIsConnected: boolean;
    version: string;
    mvpLink: string;
    showHelpLink: any;
    multipleMaxNumberofPacks: number;
    updateCallback: (key: string, value: any) => void;
}

export class AuthenticatedApp extends React.Component<IAuthenticatedAppProps, IAuthenticatedAppState> {
        
    constructor(props: IAuthenticatedAppProps) {
        super(props);
        EventHandlerProvider.Set(
            (eventHandler: EventHandlerService) => {
                this.setState({
                    eventHandler: eventHandler
                });
            }
        );

        this.state = {             
            isConnected: SignalRConnection.isConnected,
            finishedLoading: false,
            applicationData: {
                selectedLocation: sessionStorage.getItem(AuthenticationService.selectedLocationKey),
                updateCallback: (key, value) => this.updateAppData(key, value)
            } as IAuthenticatedAppData,
            eventHandler: EventHandlerProvider.GetInstance()
        };

        getJson(Endpoints.GetResources, undefined, false).then(json => {
            var res = JSON.parse(json);
            this.setState({ applicationData: { ...this.state.applicationData, resources: res } });
            Auth.init((location: string) => {this.setState({ applicationData: {...this.state.applicationData, selectedLocation:location}})});

            this.authStateUpdated(false);
        })
    }

    componentDidMount() {
        var sessionLocation = sessionStorage.getItem(AuthenticationService.selectedLocationKey);        
        if (this.state.applicationData.selectedLocation != sessionLocation) {
            this.setState({ applicationData: { ...this.state.applicationData, selectedLocation: sessionLocation } });
        }
    }

    private GetResources = (): any =>{
        if (this.state.applicationData.resources == undefined || this.state.applicationData.resources == "undefined" || this.state.applicationData.resources == null) {
            var resources = getJson(Endpoints.GetResources, undefined, false).then(json => {
                var res = JSON.parse(json);
                this.setState({ applicationData: { ...this.state.applicationData, resources: res } });
                return res;
            })
          return resources;
        }
        else {
            return this.state.applicationData.resources;
        }
    }

    componentDidUpdate() {
        if (this.state.finishedLoading) {
            var sessionLocation = sessionStorage.getItem(AuthenticationService.selectedLocationKey);
            if (sessionLocation == undefined || sessionLocation == "undefined" || sessionLocation == null) {
                if (!this.state.applicationData.locations?.length) {
                    if (this.props.location.pathname != '/Settings') {
                        var eventHandler = EventHandlerProvider.GetInstance();
                        if (!eventHandler.HasEvent()) {
                            EventHandlerProvider.GetInstance().AddEvent(new VeriLiteInformationEvent(this.GetResources().FirstTimeSetupMessage, this.GetResources().FirstTimeSetupTitle, [new VeriLiteEventAction( this.GetResources().Ok, "primary",  (currentEvent, closeModal) => { History.push('/Settings'); closeModal(); } )]));
                        }
                    }
                }
                else if (Auth.getUser().Location){
                    this.updateAppData(AuthenticationService.selectedLocationKey, Auth.getUser().Location);
                }
            }
            else {
                if (this.state.applicationData.selectedLocation == undefined || this.state.applicationData.selectedLocation == "undefined" || this.state.applicationData.selectedLocation == null) {
                    this.setState((prevState: IAuthenticatedAppState) => { return { applicationData: { ...prevState.applicationData, selectedLocation: sessionLocation } }; });
                }
            }
        }
    }

    updateAppData = (key: string, value: any) => {
        this.setState((prevState) => ({
            applicationData: { ...prevState.applicationData, [key]: value }
        }));
        if (key == AuthenticationService.selectedLocationKey) {
            sessionStorage.setItem(AuthenticationService.selectedLocationKey, value);
            SignalRConnection.syncConnection(Auth.getUser().Organisation, value);
            this.updateQueueCount(true);
            this.updateQueueCount(false);
        }
    };

    updateQueueCount = (isStoreAndForward: boolean) => {
        if (!isStoreAndForward) {
            getJson(Endpoints.GetMultipleQueueCount, undefined, true, new UserRequestHeaders({ ...Auth.getUser(), Location: this.state.applicationData.selectedLocation || sessionStorage.getItem(AuthenticationService.selectedLocationKey)}))
                .then((response) => {
                    var value = JSON.parse(response);
                    this.updateAppData("multipleQueueCount", value);
                })
                .catch(reason =>
                    console.error("Error loading multipleQueueCount. With reason: " + reason)
                );
        }
        else {
            getJson(Endpoints.GetDeferredQueueCount, undefined, true, new UserRequestHeaders({ ...Auth.getUser(), Location: this.state.applicationData.selectedLocation || sessionStorage.getItem(AuthenticationService.selectedLocationKey) }))
                .then((response) => {
                    var value = JSON.parse(response);
                    this.updateAppData("deferredQueueCount", value);
                })
                .catch(reason =>
                    console.error("Error loading deferredQueueCount. With reason: " + reason)
                );
        }
    }


    loading = () => {
        return (
            <FullView horizontal vertical>
                <Center horizontal vertical>
                    <CustomSpinner />
                </Center>
                <EventModal backdrop={"static"} />
            </FullView>
        );
    }

    authStateUpdated = (forceUpdate: boolean = true) => {
        if (Auth.State == AuthenticationState.Authenticated) {
            SignalRConnection.init( 
                Auth,
                (isConnected) =>
                    this.setState(
                        {
                            isConnected: isConnected
                        },
                        () => {
                            if (isConnected) {                                
                                SignalRConnection.syncConnection(
                                    Auth.getUser().Organisation,
                                    this.state.applicationData.selectedLocation || sessionStorage.getItem(AuthenticationService.selectedLocationKey)
                                );
                            }
                        }
                    ),
                this.updateQueueCount,
                (newConnectionState: SignalR.HubConnectionState) => {
                    this.setState({ applicationData: { ...this.state.applicationData, connectionState: newConnectionState } });
                },
                (isOnline: boolean) => {
                    this.setState({ applicationData: { ...this.state.applicationData, nbsIsConnected: isOnline } });
                },
            this.GetResources());
        }
        if (forceUpdate) {
            this.forceUpdate();
        }
    }

    render() {
        switch (Auth.State) {
            case AuthenticationState.Unauthenticated:
                return this.loading();
            case AuthenticationState.Loading:
                return this.loading();
            case AuthenticationState.Error:
                return <EventModal backdrop={"static"} />;
            case AuthenticationState.Authenticated:
                return (
                    <div>
                        <EventModal backdrop={true} />
                        {!this.state.finishedLoading ?
                            <DataLoader dataToLoad={[
                                { key: "supportedLanguages", endpoint: Endpoints.GetSupportedLanguages },
                                { key: "selectedLanguage", endpoint: Endpoints.GetSelectedLanguage },
                                { key: "userInfo", endpoint: Endpoints.GetUserInfo },
                                { key: "availableActions", endpoint: Endpoints.GetAvailableActions },
                                { key: "calibrationData", endpoint: Endpoints.GetCalibrationData },
                                { key: "locations", endpoint: Endpoints.GetLocations },
                                { key: "apiProvider", endpoint: Endpoints.GetApiProvider },
                                { key: "multipleQueueCount", endpoint: Endpoints.GetMultipleQueueCount },
                                { key: "deferredQueueCount", endpoint: Endpoints.GetDeferredQueueCount },
                                { key: "version", endpoint: Endpoints.GetVersion },
                                { key: "mvpLink", endpoint: Endpoints.GetMvpLink },
                                { key: "showHelpLink", endpoint: Endpoints.GetShowHelpLink},
                                { key: "multipleMaxNumberofPacks", endpoint: Endpoints.GetMultipleMaxNumberofPacks },
                            ]}
                                onComplete={() => { this.setState({ finishedLoading: true }); }}
                                onUpdate={(key: string, value: any) => {
                                    this.setState((prevState) => ({
                                        applicationData: { ...prevState.applicationData, [key]: value }
                                    }));
                                }}
                                siteLogo={SiteLogo}
                                isConnected={this.state.isConnected}
                                location={this.state.applicationData.selectedLocation}
                                resources={this.GetResources()}
                            />
                            :
                            <GlobalProvider value={this.state.applicationData}>
                                <IdleChecker userData = {this.state.applicationData.userInfo.InactivityTimeout} />
                                <AuthProvider value={Auth}>
                                    <Fade timeout={300}>
                                        <Layout siteLogo={SiteLogo} companyLogo={CompanyLogo}>
                                            <Switch>
                                                <Route exact path='/Dashboard/:path?/:path2?' render={(props) =>
                                                    <Dashboard {...props}
                                                        resources={this.GetResources()}
                                                        siteLogo={SiteLogo}
                                                        companyLogo={CompanyLogo}
                                                        supportedLanguages={this.state.applicationData.supportedLanguages}
                                                    />}
                                                />
                                                <Route exact path='/CalibrateScanner' render={(props) => <CalibrateScanner {...props} applicationData={this.state.applicationData} />} />
                                                <Route exact path='/Settings/:path?' render={(props) => <Settings {...props} resources={this.GetResources()} />} />
                                                <Route exact path='/EchoPage' render={(props) => <Echo />} />
                                                <Route exact path='/Downloads' render={(props) => <Downloads  applicationData={this.state.applicationData} />} />
                                                <Route render={() => <SafeRedirect to="/Dashboard/Safe" resources={this.GetResources()}/>} />
                                            </Switch>
                                        </Layout>
                                    </Fade>
                                </AuthProvider>
                            </GlobalProvider>}
                    </div>
                );
            case AuthenticationState.PasswordReset:
                console.log(this.GetResources())
                return <PasswordResetLanding resources={this.GetResources()}/>
            case AuthenticationState.TwoFactor:
                return <TwoFactorAuthentication forceAppUpdate={this.authStateUpdated} siteLogo={SiteLogo} companyLogo={CompanyLogo} resources={this.GetResources()} />
            case AuthenticationState.LicenseError:
                return <LicenseError resources={this.GetResources()}/>
        }
    }
}